import { Expose } from 'class-transformer'
import { MediaLibraryFile } from '../../entity'

export class GetMediaLibraryFileDTO {

    @Expose()
    mediaLibraryFile!: MediaLibraryFile

}
